import _ from "lodash";
import {regNavn} from "./tredjepartsTjenestenavn";
import {IDeferred, IPromise, IQService} from "angular";
import {Debugger} from 'debug'

const debug: Debugger = require('debug')('LokaltDatalager');

/**
 * Wrapper rundt loklat datalager.
 * Backet av $cordovaNativeStorage ved kjøring på cordova og av LocalStorage ved kjøring i nettleser.
 * Merk at alle operasjoner vil henge inntill {@link #initialisert()} har blitt kalt.
 * Ved kjøring på cordova må man sørge for at cordova (og native storage pluginet) har lastet ferdig
 * før initialisert() kalles.
 */
export class LokaltDatalager {

    static regNavn = 'LokaltDatalager';
    static nøkkelprefiks = 'lederplan.';

    static forInjisering() {
        return [
            regNavn.ngCordova.$cordovaNativeStorage,
            regNavn.ng.$q,
            LokaltDatalager
        ];
    }

    constructor(private datalager: ngcordova.NativeStorage, private $q:IQService) {
        this.deferredDatalager = this.$q.defer();
    }

    private erInitialisert = false;
    private deferredDatalager: IDeferred<ngcordova.NativeStorage>;

    //offentlige metoder

    /** Må kalles for å signalisere at underliggende datalager er klart for bruk. */
    initialisert(){
        debug('initialisert ');
        this.erInitialisert = true;
        this.deferredDatalager.resolve(this.datalager);
    }

    eksisterer(nøkkel: string): IPromise<boolean> {
        return this.hentDatalager()
            .then(datalager => datalager.getItem(this.medPrefiks(nøkkel)))
            .then(v => true)
            .catch(e => false);
    }

    lagre(nøkkel: string, verdi: any): IPromise<any> {
        return this.hentDatalager()
            .then(datalager => datalager.setItem(this.medPrefiks(nøkkel), verdi))
            .then(v => { debug(`lagret ${nøkkel}`, v); return v; })
            .catch(e => debug(`feil under lagring av verdi under nøkkel '${nøkkel}'`, e));
    }

    hent(nøkkel: string): IPromise<any> {
        return this.hentDatalager()
            .then(datalager => datalager.getItem(this.medPrefiks(nøkkel)))
            .catch(e => debug(`feil under fremhenting av verdi under nøkkel '${nøkkel}'`, e));
    }

    hentEllerStandardVerdi(nøkkel: string, standardVerdi: any): IPromise<any> {
        return this.hentDatalager()
            .then(datalager => datalager.getItem(this.medPrefiks(nøkkel)))
            .catch(e => {
                const melding = e.message || e;
                if (!_.endsWith(melding, ': undefined')) console.error(e);
                return standardVerdi;
            });
    }

    slett(nøkkel: string): IPromise<any> {
        return this.hentDatalager()
            .then(datalager => datalager.remove(this.medPrefiks(nøkkel)))
            .then(v => { debug(`slettet ${nøkkel}`, v); return v; })
            .catch(e => debug(`feil under sletting av nøkkel '${nøkkel}'`, e));
    }

    //hjelpemetoder

    private medPrefiks(nøkkel: string) {
        return LokaltDatalager.nøkkelprefiks + nøkkel;
    }

    private hentDatalager():IPromise<ngcordova.NativeStorage>{
        //debug(`hentDatalager ${this.erInitialisert  ? '(initialisert)':'(ikke initialisert)'}`)
        return this.deferredDatalager.promise;
    }
}

